import { Button } from '@mui/material';
import { AnalysisUseCase } from 'generated/graphql';
import { Link } from 'react-router-dom';
import { getAnalysisRoute } from 'v2/core/services/analysis/link';

interface WisdomQuantifyChartLinkProps {
  quantifyName: string;
  viewToken: string;
}

export const WisdomQuantifyChartLink = ({
  quantifyName,
  viewToken,
}: WisdomQuantifyChartLinkProps) => {
  return (
    <Button
      component={Link}
      to={getAnalysisRoute({
        name: quantifyName,
        token: viewToken,
        useCase: AnalysisUseCase.Default,
      })}
      target="_blank"
      variant="text"
      color="success"
      size="small"
    >
      View&nbsp;Quantify
    </Button>
  );
};
